import { render, staticRenderFns } from "./ScreeningResultsPills.vue?vue&type=template&id=1a8f7758&scoped=true&"
import script from "./ScreeningResultsPills.vue?vue&type=script&lang=js&"
export * from "./ScreeningResultsPills.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningResultsPills.vue?vue&type=style&index=0&id=1a8f7758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f7758",
  null
  
)

export default component.exports